export const DISPLAY_DIVISION_IN_FORM_FOR_TOURNAMENT = 'DISPLAY_DIVISION_IN_FORM_FOR_TOURNAMENT';
export const SET_EVENT_SELECTED_FOR_TOURNAMENT = 'SET_EVENT_SELECTED_FOR_TOURNAMENT';
export const SET_VIRTUAL_EVENT_SELECTED_FOR_TOURNAMENT = 'SET_VIRTUAL_EVENT_SELECTED_FOR_TOURNAMENT';
export const DISPLAY_NEW_DIVISION_FOR_TOURNAMENT = 'DISPLAY_NEW_DIVISION_FOR_TOURNAMENT';
export const CANCEL_DIVISION_FORM_FOR_TOURNAMENT = 'CANCEL_DIVISION_FORM_FOR_TOURNAMENT';
export const HIGHTLIGHT_SELECTED_EVENT_FOR_TOURNAMENT_DIVISIONS = 'HIGHTLIGHT_SELECTED_EVENT_FOR_TOURNAMENT_DIVISIONS';
export const HIGHLIGHT_SELECTED_VIRTUAL_EVENT_FOR_TOURNAMENT_DIVISIONS = 'HIGHLIGHT_SELECTED_VIRTUAL_EVENT_FOR_TOURNAMENT_DIVISIONS';
export const DISPLAY_EVENTS_FOR_TOURNAMENT_DIVISIONS = 'DISPLAY_EVENTS_FOR_TOURNAMENT_DIVISIONS';
export const DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_DIVISIONS = 'DISPLAY_VIRTUAL_EVENTS_FOR_TOURNAMENT_DIVISIONS';
export const DISPLAY_DIVISION_FOR_TOURNAMENT_EVENT = 'DISPLAY_DIVISION_FOR_TOURNAMENT_EVENT';
export const SET_DIVISION_DISPLAY_DEFAULT = 'SET_DIVISION_DISPLAY_DEFAULT';


// WEBPACK FOOTER //
// ./src/features/tournament/divisions/constants.js